import { render, staticRenderFns } from "./DatumLog.vue?vue&type=template&id=25ffba4f&scoped=true&"
import script from "./DatumLog.vue?vue&type=script&lang=js&"
export * from "./DatumLog.vue?vue&type=script&lang=js&"
import style0 from "./DatumLog.vue?vue&type=style&index=0&id=25ffba4f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ffba4f",
  null
  
)

export default component.exports